import React, { useEffect } from "react";
import { useRecoilState } from "recoil";

import useInterval from "hooks/useInterval";
import Service from "./service";
import useClickToCall from "./useClickToCall";
import ErrorView from "./errorView/errorView";
import UpdateBeforeCallView from "./updateBeforeCallView/updateBeforeCallView";
import CallMaximizedView from "./callMaximizedView/callMaximizedView";
import CallMinimizedView from "./callMinimizedView/callMinimizedView";
import { clickToCallAtom, STATUS_TIMEOUT, ACTIVE_STATE_TYPES, ACTIVE_STATE } from "./constants";

import styles from "./clickToCall.scss";

export default function ClickToCall({ profile, setProfile, lob }) {
  const [state, setState] = useRecoilState(clickToCallAtom);
  const { call } = useClickToCall();

  const { activeCall, activeState } = state;

  useEffect(() => {
    checkActiveCall();
  }, []);

  useEffect(() => {
    if(!!activeCall) {
      checkActiveState();
    }
  }, [activeCall]);

  useEffect(() => {
    if([ACTIVE_STATE_TYPES.CALL_MAXIMIZED, ACTIVE_STATE_TYPES.CALL_MINIMIZED].includes(activeState)) {
      localStorage.setItem(ACTIVE_STATE, activeState);
    }
    else localStorage.removeItem(ACTIVE_STATE);
  }, [activeState]);

  useInterval( fetchCallDetails, activeCall ? STATUS_TIMEOUT : null, true);

  function checkActiveCall() {
    const payload = { correlationId: activeCall };
    Service.fetchCallDetails({ payload, headers: { lob }}).then((res) => {
      const { data } = res;
      const { activeCall, correlationId, agentNumber, agentName, agentContactType, userNumber, userName } = data;
      if (activeCall) {
        setState((state) => ({ ...state, activeCall: correlationId, agentNumber, agentName, agentContactType, userNumber, userName }));
      }
    })
    .catch(() => setState((state) => ({ ...state, activeCall: null })));
  }

  function checkActiveState() {
    const activeStateStored = localStorage.getItem(ACTIVE_STATE);
    const callState = activeStateStored === ACTIVE_STATE_TYPES.CALL_MINIMIZED ? ACTIVE_STATE_TYPES.CALL_MINIMIZED : ACTIVE_STATE_TYPES.CALL_MAXIMIZED;
    setState((state) => ({ ...state, activeState: callState }));
  }

  function fetchCallDetails() {
    const payload = { correlationId: activeCall };
    Service.fetchCallDetails({ payload, headers: { lob }}).then((res) => {
      const { data } = res;
      const { activeCall, ...callDetails } = data;
      if (!activeCall) {
        setState((state) => ({ ...state, activeCall: null }));
      }
      setState((state) => ({ ...state, callDetails }));
    })
    .catch(() => setState((state) => ({ ...state, activeCall: null })));
  }

  function callBinded() {
    const { agentNumber, agentName, userNumber, userName, agentContactType } = state;
    call({ agentNumber, agentName, userNumber, userName, agentContactType, lob });
  }

  const component = (() => {
    switch (activeState) {
      case ACTIVE_STATE_TYPES.DISMISSED:
        return null;
  
      case ACTIVE_STATE_TYPES.ERROR:
        return <ErrorView />;
        
      case ACTIVE_STATE_TYPES.UPDATE:
        return <UpdateBeforeCallView { ...{ profile, setProfile, lob, callBinded }} />;
      
      case ACTIVE_STATE_TYPES.CALL_MAXIMIZED:
        return <CallMaximizedView callBinded={callBinded} />;
  
      case ACTIVE_STATE_TYPES.CALL_MINIMIZED:
        return <CallMinimizedView />;
        
      default:
        return null;
    }
  })();  

  return <div className={styles.click_to_call}>{component}</div>
}
